
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "_MAPBOX_CONFIG": {
    "accessToken": "pk.eyJ1IjoiY3ltZXoiLCJhIjoiY2xtNTh0MDBnM3h1ZjNrbzIwZnlpdTY4eCJ9.w_lKyBKru6wdZ8-6lbeFsg"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/opt/render/project/src/.app/app.config.ts"
import cfg1 from "/opt/render/project/src/layers/tairo-layout-sidebar/app.config.ts"
import cfg2 from "/opt/render/project/src/layers/tairo-layout-collapse/app.config.ts"
import cfg3 from "/opt/render/project/src/layers/tairo/app.config.ts"
import cfg4 from "/opt/render/project/src/node_modules/.pnpm/@shuriken-ui+nuxt@3.1.5_nuxt@3.13.1_ts-node@10.9.2_vue@3.5.13/node_modules/@shuriken-ui/nuxt/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, cfg1, cfg2, cfg3, cfg4, inlineConfig)
